export var salaryType = [{
  value: "hourlyBased",
  label: "Hourly-based"
}, {
  value: "dayBased",
  label: "Day-based"
}];
export var salaryMetric = [{
  value: "workedHours",
  label: "Total Worked Hours"
}, {
  value: "productiveHours",
  label: "Productive Hours"
}, {
  value: "activeTime",
  label: "Active Time"
}, {
  value: "neutralTime",
  label: "Neutral Hours"
}, {
  value: "neutralProductiveTime",
  label: "Neutral Hours + Productive Hours"
}];
export var currency = [{
  value: "INR",
  label: "₹ (INR)",
  symbol: "₹"
}, {
  value: "USD",
  label: "$ (USD)",
  symbol: "$"
}, {
  value: "EUR",
  label: "€ (EUR)",
  symbol: "€"
}, {
  value: "GBP",
  label: "£ (GBP)",
  symbol: "£"
}];